export type TFieldConfig = {
  name: string;
  type?:
    | SafeExtract<
        TInputTypes,
        | 'Radio'
        | 'Select'
        | 'SelectAndAdd'
        | 'Checkbox'
        | 'CheckboxSingle'
        | 'NumberField'
        | 'TextField'
        | 'TextArea'
        | 'PartialDate'
      >
    | 'NumberRange'; // what is this numberrange??
  options?: Array<string | number>;
  optionFormatter?: (o: string | number) => string;
  placeholder?: string;
  limit?: number;
};

export type TSleep = ININMTPreInquiry['sleep'] | ITreatmentMonitoringInquiry['sleep'];

export const ninmtSurveyTypes: TMyDocumentType[] = [
  'bdi',
  'bai',
  'ninmtPreInquiry',
  'contraIndicationsInquiry',
  'treatmentMonitoringInquiry',
  'treatmentEfficiency',
  'tdcsReport',
  'supplyShortagesInquiry',
  'eq5d',
];

export const srSurveyTypes: TMyDocumentType[] = [
  'ess',
  'isi',
  'copd',
  'dss',
  'sleepApneaFirstVisitInquiry',
  'deviceTherapyControlVisitInquiry',
  'deps',
  'des',
  'eq5d', // EQ-5D-5L
  'satisfactionWithCare',
  'sleepApneaBackground',
];
export const smaDMDSurveyTypes: TMyDocumentType[] = ['pedsql'];

export const parkinsonSurveyTypes: TMyDocumentType[] = [
  'eq5d', // EQ-5D-5L, though not in requirements, NEUR-5314
  'nmsq',
  'impulseControlSurvey',
  'mdsUpdrsIV',
  'pdq8',
  'parkinsonMobileBackground',
  'parkinsonLifestyle',
  // Surveys below might be moved to Alzheimer platform if implemented
  'memory',
  'bdi',
  'gds15',
];

export const mgravisSurveyTypes: TMyDocumentType[] = [
  // Remember this specific order
  'mgadl', // Only for viewing patient entered ones, professionals should input these in functionalPerformanceMgravis section
  'fss',
  'eq5d', // EQ-5D-5L
  'passQuestion',
  'mgravisBackground',
  'mgQol15r', // Only for viewing patient entered ones
  'mgFatigueDiary',
];

export const msSurveyTypes: TMyDocumentType[] = [
  'predss',
  'status',
  'eq5d',
  'qualityoflife',
  'fsmc',
  'msnq',
  'msBackground',
  'msLifestyle',
];

export const parkinsonInformantSurveyTypes: TMyDocumentType[] = ['iadl', 'fbimod', 'memory'];

export const surveysByPlatform: { [platform in Platform]?: Array<TMyDocumentType> } = {
  ninmt: ninmtSurveyTypes,
  sleepApnea: srSurveyTypes,
  sma: smaDMDSurveyTypes,
  dmd: smaDMDSurveyTypes,
  parkinson: parkinsonSurveyTypes,
  mgravis: mgravisSurveyTypes,
  ms: msSurveyTypes,
};

export const informantSurveysByPlatform: { [platform in Platform]?: Array<TMyDocumentType> } = {
  parkinson: parkinsonInformantSurveyTypes,
};
